module.exports = __webpack_public_path__ + "assets/img/prize1-e6a94bb4.png";